import { useContext, useState } from "react";
import { GlobalContext } from "../../../../global/context/Provider";
import { SelectUserReceta } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { PortalContext } from "../../../context/Provider";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import "./PreguntaReceta.css";

const PreguntaReceta = ({ titulo, dissmiss }) => {
  const {
    listaFamiliaresState,
    selectDropDownDispatch,
    selectDropDownState,
  } = useContext(PortalContext);

   // Cambio de contexto
   const {
    authState,
    toasterDispatch
  } = useContext(GlobalContext);

  const [userSelect, setUserSelect] = useState(false);

  const onChangeDropdownReceta = (e) => {
    if (e !== "") {
      if (e.id && e.familiar && e.verResultados) {
        setUserSelect(e.id);
        SelectUserReceta(e)(selectDropDownDispatch);
      } else if (e.id !== authState.auth.data.paciente.codigo) {
        showToaster(
            {
              texto: "No tenés permiso para realizar recetas sobre este familiar",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
      } else {
        setUserSelect(authState.auth.data.paciente.codigo);
        SelectUserReceta(false)(selectDropDownDispatch);
      }
    }
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-preguntaReceta-body">
        <p className="rb18m">¿Para quién desea solicitar la receta digital?</p>
        <div>
          <Dropdown
            valor={
              selectDropDownState.selectDropDown.recetaDigital.pacienteElegido
                ? selectDropDownState.selectDropDown.recetaDigital
                    .pacienteElegido.id
                : authState.auth.data.paciente.codigo
            }
            datos={dropdownFamiliares(
              listaFamiliaresState,
              authState,
              "VerResultados"
            )}
            campoCodigo="id"
            descripcion="nombre"
            placeholder={"Elige un usuario"}
            onChange={onChangeDropdownReceta}
            notSearch={true}
            heightLista={"auto"}
          />
        </div>
      </div>
    </>
  );
};

export default PreguntaReceta;
